// src/frontend/client/src/config.js

// 1. Detectamos si estamos en "El Taller" (Localhost)
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// 2. Definimos las direcciones
const URL_NUBE = 'https://wilsync-backend-962363115131.us-central1.run.app/api';
const URL_LOCAL = 'http://127.0.0.1:8000/api';

// 3. Exportamos la correcta automáticamente
export const API_BASE_URL = isLocalhost ? URL_LOCAL : URL_NUBE;

console.log(`🔌 Conectado a: ${isLocalhost ? 'TALLER (Local)' : 'TIENDA (Nube)'}`);